import React, { useEffect, useState, useRef } from 'react';

const easeOutQuart = t => 1 - Math.pow(1 - t, 4);

export default function AnimatedCounter({ value, duration = 2000, decimals = 0, prefix = '', suffix = '' }) {
  const [count, setCount] = useState(0);
  const startTimeRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    const startValue = 0;
    const endValue = typeof value === 'number' ? value : parseFloat(value) || 0;
    
    const animate = (currentTime) => {
      if (!startTimeRef.current) startTimeRef.current = currentTime;
      
      const elapsed = currentTime - startTimeRef.current;
      const progress = Math.min(elapsed / duration, 1);
      
      const easedProgress = easeOutQuart(progress);
      const currentCount = startValue + (endValue - startValue) * easedProgress;
      
      setCount(currentCount);
      
      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      }
    };
    
    animationFrameRef.current = requestAnimationFrame(animate);
    
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      startTimeRef.current = null;
    };
  }, [value, duration]);

  return (
    <span>
      {prefix}{count.toFixed(decimals)}{suffix}
    </span>
  );
}
